import React from 'react';

import { OverrideComponents } from './OverrideComponents';
import { OverrideHooks } from './OverrideHooks';

export interface OverrideRegistry {
  register: (components: OverrideComponents) => void;
  registerHooks: (hooks: OverrideHooks) => void;
  createProxy: () => OverrideComponents;
  createHookProxy: () => OverrideHooks;
}

export const createOverrideRegistry = (): OverrideRegistry => {
  const registry = new Map<string, React.ComponentType<any>>();
  const hookRegistry = new Map<string, (...args: any[]) => any>();

  const register = (components: OverrideComponents) => {
    Object.entries(components).forEach(([name, component]) => {
      registry.set(name, component);
    });
  };

  const registerHooks = (hooks: OverrideHooks) => {
    Object.entries(hooks).forEach(([name, hook]) => {
      hookRegistry.set(name, hook);
    });
  };

  const createProxy = (): OverrideComponents => {
    return new Proxy(
      {},
      {
        get: (_, prop: string) => {
          return registry.get(prop);
        },
      },
    ) as any;
  };

  const createHookProxy = (): OverrideHooks => {
    return new Proxy(
      {},
      {
        get: (_, prop: string) => {
          return hookRegistry.get(prop);
        },
      },
    ) as any;
  };

  return { register, registerHooks, createProxy, createHookProxy };
};
